import React from "react";
import LazySection from "../../react-only-components/LazySection";
import { IFrameModel } from "./models/IFrame.model";
import { TIFrameProps } from "./types/IFrame.types";
import "./index.scss";

const IFrame = (props: TIFrameProps) => {
  const model = new IFrameModel(props);
  const { url } = model;

  return (
    <LazySection>
      {props.fields && (
        <section className={"iframe"}>
          <iframe src={url}></iframe>
        </section>
      )}
    </LazySection>
  );
};

export default IFrame;
